import { z } from "zod";

const IndexFilterSchema = z.object({
    preferred_currency: z.nullable(z.string()).optional(),
    property_type: z.nullable(z.string()).optional(),
    is_property_active: z.nullable(z.string()).optional(),
    // '1' = only properties whose billing_type looks wrong for their room count
    // (see PropertiesTable's ROOM_COUNT_THRESHOLD alert).
    needs_review: z.nullable(z.string()).optional(),
    // Group id (dev only in the UI); '' = all groups.
    group_id: z.nullable(z.string()).optional(),
    // '1' = billing connected, '0' = not connected (dev only in the UI); '' = all.
    billing_connected: z.nullable(z.string()).optional(),
});

export { IndexFilterSchema };
export type IndexFilter = z.infer<typeof IndexFilterSchema>;